import { combineReducers } from "redux";
import reducerBoardPosition from "./reducerBoardPosition.js";

const appReducer = combineReducers({
  reducerBoardPosition,
});

const rootReducer = (state, action) => {
  if (action.type === "FEN_CHANGED") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
